<style lang="scss">
  @import "@/assets/scss/vuexy/components/valueItem";
</style>
<template>
  <div class="p-2">
      <div class="device-info vx-col w-full">
          <div class="shadow-drop d-theme-dark-bg round" v-if="img !== undefined">
              <img :src="getImgUrl(img)" class="info-icon p-2 block" alt="ícono sensor"/>
          </div>
          <div class="device-text-container" v-if="!relativeTime">
              <span class="main-info">
                  {{ value }} <span class="unit">{{unit}}</span>
              </span>
              <span class="subtext-info">
                  {{description}}
              </span>
          </div>
          <div class="device-text-container" v-if="relativeTime">
              <span class="main-info">
                  {{relativeTimeConvert(value)}}
              </span>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    value: String,
    unit: String,
    img: String,
    description: String,
    min: {
      type: String,
      default: ''
    },
    max: {
      type: String,
      default: ''
    },
    relativeTime: Boolean
  },
  methods: {
    getImgUrl (name) {
      const val = parseFloat(this.value)
      const min = parseFloat(this.min)
      const max = parseFloat(this.max)
      const images = require.context('@/assets/images/icons/', false, /\.svg$/)
      if (this.min !== '' && this.max !== '') {
        let color = ''
        if (val > max || val < min) color = 'red'
        else color = 'blue'
        return images(`./${name}_${color}.svg`)
      } else {
        return images(`./${name}.svg`)
      }
    },
    relativeTimeConvert (date) {
      date.replace(' ', 'T')
      return this.$dayjs().to(this.$dayjs(date))
    }
  }
}
</script>
